import Swiper from 'swiper';
import { Navigation, Keyboard, A11y } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation'; // Recommended to import module-specific CSS if needed by your bundler

export default class StoriesSlider {
  static init() {
    const sliders = document.querySelectorAll('.stories-slider');

    sliders.forEach((sliderSection) => {
      const swiperEl = sliderSection.querySelector('.swiper');
      if (!swiperEl) return;

      const nextBtn = sliderSection.querySelector('.stories-slider__navigation-next');
      const prevBtn = sliderSection.querySelector('.stories-slider__navigation-prev');
      const videos = sliderSection.querySelectorAll('.stories-slider__video');

      // 1. Initialize Swiper
      const swiper = new Swiper(swiperEl, {
        modules: [Navigation, Keyboard, A11y],
        slidesPerView: 1.2,
        spaceBetween: 20,
        grabCursor: true, // Added to match your example preference
        observer: true,
        observeParents: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        a11y: true,
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },
        breakpoints: {
          640: {
            slidesPerView: 2.5,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 4,
            spaceBetween: 24,
          },
        },
        // Pause all videos when swiping to avoid overlapping audio
        on: {
          slideChangeTransitionStart: () => {
            pauseAllVideos();
          },
        },
      });

      // 2. Video Play/Pause Logic
      const pauseAllVideos = () => {
        videos.forEach((vid) => {
          vid.pause();
          const card = vid.closest('.stories-slider__card');
          if (card) card.classList.remove('is-playing');
        });
      };

      const toggleVideo = (video, card) => {
        if (video.paused) {
          pauseAllVideos(); // Ensure only one plays at a time
          video.play();
        } else {
          video.pause();
        }
      };

      // Attach listeners to videos and cards
      videos.forEach((video) => {
        const card = video.closest('.stories-slider__card');
        const playBtn = card.querySelector('.stories-slider__play-btn');

        // Play button click
        if (playBtn) {
          playBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            toggleVideo(video, card);
          });
        }

        // Card click (to pause if currently playing)
        if (card) {
          card.addEventListener('click', () => {
            if (!video.paused) {
              video.pause();
            }
          });
        }

        // Native video events to reliably sync the UI play button state
        video.addEventListener('play', () => card.classList.add('is-playing'));
        video.addEventListener('pause', () => card.classList.remove('is-playing'));
        video.addEventListener('ended', () => card.classList.remove('is-playing'));
      });
    });
  }
}